import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Label } from 'globals/store/events.data';


@Component({
    selector: 'label-toggle-bar',
    imports: [CommonModule],
    template: `
<div [ngClass]="{ disabled: disabled, nested: nested }" (click)="toggleLabel.emit()" class="item smooth colored-label">
  <div class="bar" [ngClass]="{selected: selected }" [ngStyle]="{backgroundColor: color}">
    <icon class="lbl"  [ngStyle]="{color: color}" matIcon="label"></icon>
    <div class="lbl_title">{{ text }}</div>
    <div style="flex:1"></div>
    <icon class="check" [ngClass]="{selected: true, invisible: !selected}" icon="tick_24px"></icon>
    <div class="bg"></div>
  </div>
</div>
`,
    styleUrls: ['./label-toggle-bar.sass'],
    standalone: true
})
export class LabelToggleBar {
  @Input() disabled = false
  @Input() selected = false
  @Input() nested = false
  @Input() text = ''
  @Input() color = '#000'

  @Output() toggleLabel: EventEmitter<null> = new EventEmitter() 
}